/**
 * Pure render-gate decision — no Node.js dependencies, so it is safe to import
 * from the browser entry alongside the rule engine.
 */
export function shouldBlockRender(
  strictErrors: boolean,
  strictAll: boolean,
  totalErrors: number,
  totalWarnings: number,
): boolean {
  return (strictErrors && totalErrors > 0) || (strictAll && (totalErrors > 0 || totalWarnings > 0));
}
